import './styles.css';
import { state } from './modules/state.js';
import { UI } from './modules/ui.js';
import { Events } from './modules/events.js';
import { Resizer } from './modules/resizer.js';
import { Actions } from './modules/actions.js';
import { ThemeManager } from './modules/themes.js';

const App = {
  init() {
    // Restore persisted theme before first paint
    state.theme = ThemeManager.restore();

    UI.updateLayoutControls();
    UI.updateOptionControls();
    UI.updateThemeControls();
    Events.bind();
    Resizer.init();
    Actions.loadSample('person');

    // Version available in DevTools console for debugging
    console.info(`JSON Parser v${__APP_VERSION__} (${__BUILD_DATE__})`);
  },
};

App.init();
